import * as React from "react";
import BasePopup from "../../../popups/BasePopup.jsx"
import { styled } from "@mui/material/styles";

const StyledDataList = styled('dl')({
  borderCollapse: "collapse",
  width: "100%",
  "& > :nth-of-type(odd)": {
    backgroundColor: "rgba(150, 150, 150, 0.2)",
  },
  "& div": {
    display: "flex",
    marginRight: "1rem",
  },
  "& div dt": {
    flexShrink: 0,
    fontWeight: "bold",
    width: "120px",
    paddingLeft: "5px",
  },
  "& div dd": {
    flexGrow: 1,
    marginLeft: 0,
    paddingLeft: "10px",
    paddingRight: "5px",
  },
})

const renderDataList = (title, rows, first=false) => {
  return (
    <>
      <h2 style={{
        marginTop: 0,
        padding: first ? 0 : "1rem 0 0 0",
      }}>
        {title}
      </h2>
      <StyledDataList>
        {rows.map(([label, value]) => renderDataListItem(label, value))}
      </StyledDataList>
    </>
  )
}

const renderDataListItem = (label, value) => {
  return (
    <div key={label}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  )
}

const NonRetailPoiPopup = ({ data }) => {
  const props = data.properties

  return (
    <BasePopup
      coords={data.coords}
      offset={1}
      anchor="bottom"
      maxWidth="480px"
      style={{
        color: "black",
        fontSize: "13px",
        width: "auto",
        height: "410px",
        overflowY: "hidden",
      }}>

      <div style={{
        paddingLeft: "1rem",
        marginTop: "0.5rem",
        width: "100%",
        maxHeight: "calc(400px - 2rem)", // Account for popup box margins
        overflowY: "scroll",
      }}>
          {renderDataList("Organisation", [
              ["Name", props.name],
              ["Category", props.group_name],
              ["Use class", props.category_name],
              ["Sub class", props.class_name],
          ], true)}

        {renderDataList("Address", [
              ["Address 1", props.address_detail],
              ["Address 2", props.street_name],
              ["Postcode", props.postcode],
        ])}
      </div>
    </BasePopup>
  )
}

export default NonRetailPoiPopup;